export enum typologies{
    Aerea = 'Aérea',
    Subterranea = 'Subterranea'
}